import Vue from 'vue';
import noty from './noty.service';

export default {
    async getByClient(clientId) {
        return (await Vue.http.get(`/api/branches/${clientId}`)).data;
    },
    async get(clientId, branch) {
        return (await Vue.http.get(`/api/branches/${clientId}/${branch}`)).data;
    },
    async create(branch) {
        let b = (await Vue.http.post('/api/branches/create', branch)).data;
        noty.success(`Branch '${b.branch}' created successfully`);
        return b;
    },
    async update(branch) {
        let b = (await Vue.http.post('/api/branches/update', branch)).data;
        noty.success(`Branch '${b.branch}' update successfully`);
        return b;
    },
    async saveSettings(clientId, branch, settings) {
        let s = (await Vue.http.post(`/api/branches/${clientId}/${branch}/settings`, settings)).data;
        noty.success(`Settings for branch '${branch}' saved successfully`);
        return s;
    },
    async getPaymentSettings(clientId, branch) {
        return (await Vue.http.get(`/api/branches/${clientId}/${branch}/settings/ps`)).data;
    }
};


// WEBPACK FOOTER //
// ./src/services/branch.service.js